<template>
    <div class="page-shell page">
        <div class="page-header">
            <div class="toolbar">
                <span class="hint">用户在 Google 登录后自动入库；在此管理角色与启停。</span>
            </div>
        </div>
        <div class="page-body page-body--table-sticky">
        <el-table :data="data" v-loading="loading" stripe border :height="table_area_height">
            <el-table-column label="姓名" prop="name" width="140"></el-table-column>
            <el-table-column label="邮箱" prop="email" min-width="200"></el-table-column>
            <el-table-column label="角色" width="120">
                <template #default="scope">
                    <el-tag :type="scope.row.role === 'admin' ? 'danger' : 'info'">{{ scope.row.role }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="100">
                <template #default="scope">
                    <el-tag :type="scope.row.active ? 'success' : 'info'">{{ scope.row.active ? '启用' : '禁用' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="160">
                <template #default="scope">
                    <el-button link @click="toggle_active(scope.row)">{{ scope.row.active ? '禁用' : '启用' }}</el-button>
                    <el-button link @click="toggle_role(scope.row)">{{ scope.row.role === 'admin' ? '设为用户' : '设为Admin' }}</el-button>
                </template>
            </el-table-column>
        </el-table>
        </div>
    </div>
</template>

<script>
import axios from 'ts-axios-new';
import {load_shared_data} from '../libs/sharedData';
import {showHttpError} from '../libs/errorDisplay';
import {tableAreaHeightMixin} from '../libs/tableAreaHeight';

export default {
    name: 'UserManage',
    mixins: [tableAreaHeightMixin],
    data() {
        return {
            loading: false,
            data: [],
        };
    },
    mounted() {
        if (this.$root.user.role !== 'admin') {
            this.$router.replace({name: 'MediationGroups'});
            return;
        }
        this.init();
    },
    methods: {
        init() {
            this.loading = true;
            axios.get('/cms/v1/user').then(res => {
                this.data = res.data.data.userList;
            }).finally(() => {
                this.loading = false;
            });
        },
        update_user(row, payload) {
            this.loading = true;
            axios.put('/cms/v1/user', { email: row.email, ...payload }).then(res => {
                Object.assign(row, res.data.data);
                load_shared_data(this.$root);
            }).catch((err) => {
                showHttpError(err, '更新失败');
            }).finally(() => {
                this.loading = false;
            });
        },
        toggle_active(row) {
            this.update_user(row, {active: !row.active});
        },
        toggle_role(row) {
            this.update_user(row, {role: row.role === 'admin' ? 'user' : 'admin'});
        },
    },
}
</script>

<style scoped>
.page .toolbar { margin-bottom: 0; }
.hint {
    color: var(--el-text-color-secondary);
    font-size: 13px;
}
</style>
